<template>
  <v-container fluid tag="section">
    <v-row justify="center">
      <v-col>
        <v-alert dense outlined elevation="1" type="info" color="blue" class="pa-2">
          <b>
            • Qualquer alteração realizada nesta ferramenta será aplicada de maneira
            <u class="cPrimary">individual</u>
            no sistema conectado.
            <u class="cPrimary">Para que as alterações sejam concluídas</u>
            , é necessário que os usuários realizem o
            <u class="cPrimary">logout</u>
            e, em seguida, efetuem o
            <u class="cPrimary">login</u>
            novamente no sistema.
          </b>
          <br />
          <br />
          <b>
            •
            <u class="cPrimary">Em breve</u>
            será implementado na tela de listagem um botão para
            <u class="cPrimary">replicar as alterações em outras empresas</u>
            .
          </b>
        </v-alert>
        <base-material-card color="primary" icon="mdi-label-multiple-outline" inline class="ml-0 px-5 py-3">
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">Categorias</div>
          </template>

          <v-btn
            color="success"
            dark
            elevation="1"
            class="mt-5"
            style="float: left"
            relative
            text
            medium
            @click="$router.push('/administracao/categorias/edit')"
          >
            <v-icon left size="30px">mdi-plus-circle</v-icon>
            Nova Categoria
          </v-btn>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="break-search bs-powerups ml-auto mt-4"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px"
          />
          <v-divider class="mt-10" />
          <v-data-table
            class="categorias-table"
            :headers="headers"
            :items="items"
            :search.sync="search"
            :header-props="{
              sortByText: 'Ordenar Por'
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página'
            }"
            no-data-text="Nenhuma categoria disponível"
            no-results-text="Nenhum registro correspondente encontrado"
            :mobile-breakpoint="800"
            :loading="loading"
          >
            <template v-slot:[`item.categoria_privada`]="{ item }">
              <span style="font-weight: bold" :style="!item.categoria_privada ? 'color: green' : 'color: red'">
                {{ item.categoria_privada ? 'Sim' : 'Não' }}
              </span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                min-width="0"
                class="ml-n1 px-1"
                fab
                icon
                x-small
                @click="$router.push(`/administracao/categorias/edit/${item.id}`)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`footer.page-text`]>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on" @click="getAll()">mdi-refresh</v-icon>
                </template>
                <span>Clique aqui para recarregar as categorias</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CategoriasService from '@/services/CategoriasService';

  export default {
    data: () => ({
      items: [],
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Privada',
          value: 'categoria_privada'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-3'
        }
      ],
      loading: false
    }),

    mounted() {
      this.getAll();
    },

    methods: {
      getAll() {
        this.loading = true;
        this.items = [];

        CategoriasService.getAll()
          .then((response) => (this.items = response.data.data))
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar as categorias.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .categorias-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .categorias-table table tr td:nth-child(3) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-categorias {
      width: 195.33px !important;
    }
  }
</style>